import { Box, Heading, Text, UnorderedList, ListItem } from "@chakra-ui/react";
import { ReactElement } from "react";

export default function TermsOfUseBox(): ReactElement {
  return (
    <Box
      fontFamily="Noto Sans CJK JP"
      fontSize="12px"
      p={2}
      border="1px solid"
      borderColor="gray.300"
      borderRadius="md"
      w="full"
      maxH="150px"
      overflowY="auto"
    >
      <Heading size="sm" textAlign="center" mb={4}>
        ◆音声バイオマーカー ID 利用規約
      </Heading>
      <Text fontWeight="medium">
        音声バイオマーカー
        ID利用規約（以下「本規約」といいます。）は、マツダ株式会社（以下「当社」といいます。）がお客様の登録する「音声バイオマーカー
        ID」（以下「ID」といいます。）を通じて提供する当社指定のサービス（以下「本サービス」といいます。）の利用条件及び利用上の注意事項等を定めるものです。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第１条（本規約の適用）
      </Text>
      <Text fontWeight="medium">
        本規約は、ID及び本サービスをご利用になる全てのお客様（次条で定義するユーザーといいます。）に適用されます。ユーザーは、本規約に同意のうえ、当社が別途提供するウェブサイトにアクセスして、あるいはアプリを使用して本サービスを利用するものとします。当社は、個別の本サービスについて、固有の利用条件等を定めた規約（以下「関連規約」といいます。）を別途設けることがあります。ユーザーは、本サービスをご利用になる場合には、本規約に加えて、関連規約の定めも遵守するものとします。なお、本規約の定めと関連規約の定めが矛盾する場合には、関連規約の定めが優先して適用されるものとします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第２条（定義）
      </Text>
      <Text fontWeight="medium">
        本規約において使用する用語は、次の各号に定める意味を有するものとします。
      </Text>
      <Text fontWeight="medium">
        「ユーザー」とは、利用登録を行って本サービスを利用する者をいいます。
      </Text>
      <Text fontWeight="medium">
        「ID」とは、当社がユーザーを識別するための符合であり、ユーザーがユーザー向けのサービスの利用登録を行うために自ら登録したメールアドレスをいいます。
      </Text>
      <Text fontWeight="medium">
        「PW」とは、ユーザーがユーザー向けのサービスの利用登録を行うために自ら設定したパスワードをいいます。
      </Text>
      <Text fontWeight="medium">
        「個人情報」とは、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができるものを含みます。）をいいます。
      </Text>
      <Text fontWeight="medium">
        「当社グループ会社」とは、当社の子会社、関連会社及びその他の関係会社をいい、当社と特約販売契約を締結する特約販売会社を含むものとします。
      </Text>
      <Text fontWeight="medium">
        「当社等」とは、当社及び当社グループ会社を総称していいます。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第３条（登録）
      </Text>
      <Text fontWeight="medium">
        ユーザーは、当社が別途指定する方法で氏名・住所・電話番号・生年月日・メールアドレス、PWその他当社が指定する情報（以下「登録情報」といいます。）を入力して、利用登録（以下「利用登録」といいます。）を行い、ユーザーとなることにより、本サービスを利用することができます。
      </Text>
      <Text fontWeight="medium">
        当社は、ユーザーの承諾を得ることなく、本サービス内容の全部若しくは一部を追加、変更または削減することができるものとします。
      </Text>
      <Text fontWeight="medium">
        ユーザーは、本サービスを利用する場合には、本規約に加えて、関連規約を含む当社が別途定める利用規約を遵守するものとします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第４条（ID及びPWの管理責任）
      </Text>
      <Text fontWeight="medium">
        ユーザーは、自己の責任において、自己のID及びPW（以下「ID等」といいます。）を使用及び管理するものとし、これらの使用上の過誤または第三者の不正な使用等による損害等について、当社は一切責任を負いません。
      </Text>
      <Text fontWeight="medium">
        ユーザーは、自己のID等を第三者に公表、譲渡、売買若しくは貸与等し、またはその他の方法で第三者に使用させてはならないものとします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第５条（利用登録の条件）
      </Text>
      <Text fontWeight="medium">
        ユーザーになろうとする者は、登録情報を入力して利用登録の申込みを行い、当社の承認を受けるものとします。当社の承認が完了した時点で、本サービスの利用が可能となります。
      </Text>
      <Text fontWeight="medium">
        ユーザーになろうとする者は、利用登録の申込みにあたり、真実かつ正確な情報を入力するものとし、また、ユーザーは利用登録後も、登録情報が最新の内容となるように、登録情報を適宜変更するものとします。
      </Text>
      <Text fontWeight="medium">
        ユーザーが前項の履行を怠ったことにより不利益を被った場合であっても、当社は、これについて一切責任を負いません。
      </Text>
      <Text fontWeight="medium">
        当社は、利用登録の申込者が次の各号のいずれかに該当する場合には、当該利用登録の申込みを承認せず、または既になされた利用登録を取り消すことがあります。
      </Text>
      <UnorderedList fontWeight="medium" spacing={1} mt={2}>
        <ListItem>実在しない場合</ListItem>
        <ListItem>
          仮名または他人の名義を使用または盗用して申込をした場合
        </ListItem>
        <ListItem>
          申込内容に虚偽、不正確、誤記または記入漏れ等がある場合
        </ListItem>
        <ListItem>
          反社会的勢力に該当する場合、または反社会的勢力と関係を有する場合
        </ListItem>
        <ListItem>本規約の内容に同意いただけない場合</ListItem>
        <ListItem>本規約の定めに違反している場合</ListItem>
        <ListItem>
          その他当社がユーザーになる者として不適当と判断した場合
        </ListItem>
      </UnorderedList>
      <Text fontWeight="bold" mt={2}>
        第６条（登録情報の変更）
      </Text>
      <Text fontWeight="medium">
        ユーザーは、登録情報に変更があった場合には、当社所定の方法に従い、速やかに変更後の情報を当社に通知するものとします。
      </Text>
      <Text fontWeight="medium">
        ユーザーが前項の通知を怠ったことにより不利益を被った場合であっても、当社は、これについて一切責任を負いません。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第７条（登録の解除）
      </Text>
      <Text fontWeight="medium">
        ユーザーは、当社に申し出ることによりいつでも利用登録を解除することができます。なお、本サービスの利用を停止または終了する場合には、本規約とは別に当社が定める利用規約の定めに従い、別途手続が必要となる場合があります。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第８条（登録の抹消等）
      </Text>
      <Text fontWeight="medium">
        当社は、ユーザーが次の各号のいずれかに該当すると判断した場合には、ユーザーに事前に通知することなく、当該ユーザーによる本サービスの利用を一時的に停止し、または利用登録を抹消することができるものとします。
      </Text>
      <UnorderedList fontWeight="medium" spacing={1} mt={2}>
        <ListItem>ユーザーが実在しない場合</ListItem>
        <ListItem>
          仮名または他人の名義を使用または盗用して登録をした場合
        </ListItem>
        <ListItem>
          登録情報に虚偽、不正確、誤記または記入漏れ等がある場合
        </ListItem>
        <ListItem>登録情報をユーザーの要請により削除した場合</ListItem>
        <ListItem>半年以上の間、ログインがない場合</ListItem>
        <ListItem>
          反社会的勢力に該当する場合、または反社会的勢力と関係を有する場合
        </ListItem>
        <ListItem>本規約の内容に同意いただけない場合</ListItem>
        <ListItem>本規約の定めに違反した場合</ListItem>
        <ListItem>その他当社がユーザーとして不適当と判断した場合</ListItem>
      </UnorderedList>
      <Text fontWeight="bold" mt={2}>
        第９条（登録の解除または登録抹消の効果）
      </Text>
      <Text fontWeight="medium">
        ユーザーは、利用登録を解除し、または登録を抹消され、ユーザーでなくなった場合には、本サービスが利用できなくなります。ただし、登録の解除または登録の抹消の時期によっては、メールマガジンの配信の停止またはダイレクトメールの発送、SMSやSNSでの通知の停止等が遅れることがあります。
      </Text>
      <Text fontWeight="medium">
        当社は、ユーザーが利用登録を解除し、または利用登録を抹消された場合には、登録情報及び本サービスに関連して取得したユーザーの個人情報を削除します。ただし、ユーザーより提供された情報のうち、個人情報以外の情報（匿名加工情報を含みます。）については、統計資料等として利用を継続する場合があります。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第10条（禁止事項）
      </Text>
      <Text fontWeight="medium">
        ユーザーは、本サービスを利用するにあたり、次の各号に定める行為をしてはならないものとします。
      </Text>
      <UnorderedList fontWeight="medium" spacing={1} mt={2}>
        <ListItem>他者のID等を不正に取得または使用する行為</ListItem>
        <ListItem>他者のID等を用いて本サービスを利用する行為</ListItem>
        <ListItem>当社または第三者の知的財産権を侵害する行為</ListItem>
        <ListItem>
          当社または第三者の財産・権利・プライバシーを侵害する行為
        </ListItem>
        <ListItem>当社または第三者の名誉・信用を毀損する行為</ListItem>
        <ListItem>
          有害なコンピュータープログラム等を送信し、または書き込む行為
        </ListItem>
        <ListItem>
          国内外のネットワークを経由して通信を行う場合には、経由する国内外のネットワークの規則に反する行為
        </ListItem>
        <ListItem>本サービスの運営を妨げ、またはそのおそれのある行為</ListItem>
        <ListItem>法令または公序良俗に違反する行為</ListItem>
        <ListItem>本規約の定めに違反する行為</ListItem>
        <ListItem>その他当社が不適切と判断する行為</ListItem>
      </UnorderedList>
      <Text fontWeight="bold" mt={2}>
        第11条（権利譲渡の禁止）
      </Text>
      <Text fontWeight="medium">
        ユーザーは、本サービスを利用する権利を第三者に譲渡し、または担保に供することはできません。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第12条（利用の停止または終了）
      </Text>
      <Text fontWeight="medium">
        当社は、ユーザーが以下の事由のいずれかに該当する場合には、ユーザーに事前に通知することなく、本サービスの全部または一部の利用を停止または終了させることができるものとします。また、これによりユーザーに損害が生じた場合でも、当社は一切責任を負いません。
      </Text>
      <Text fontWeight="medium">
        利用登録を自ら解除し、または抹消された場合
      </Text>
      <Text fontWeight="medium">
        反社会的勢力に該当する場合、または反社会的勢力と関係を有する場合
      </Text>
      <Text fontWeight="medium">本規約の定めに違反した場合</Text>
      <Text fontWeight="medium">
        その他当社がユーザーとして不適当と判断した場合
      </Text>
      <Text fontWeight="bold" mt={2}>
        第13条（個人情報の取扱い）
      </Text>
      <Text fontWeight="medium">
        当社は、ユーザーの個人情報を本規約及び当社の公式ウェブサイト掲載の「個人情報の取扱い」、並びに個人情報保護法その他関連法令等に基づき、適切に取り扱うものとします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第14条（個人情報の利用目的）
      </Text>
      <Text fontWeight="medium">
        当社は、ユーザーの個人情報を、以下に定める利用目的の範囲内で利用します。
      </Text>
      <UnorderedList fontWeight="medium" spacing={1} mt={2}>
        <ListItem>ユーザーへのお知らせ等の発送・発信</ListItem>
        <ListItem>本サービスの提供</ListItem>
        <ListItem>
          当社等が取り扱う商品及び提供する各種サービスに関する企画、開発、宣伝、販売・サービス活動、品質向上、リコールへの対応
        </ListItem>
        <ListItem>
          当社等の商品・サービス企画、開発、お客様満足度向上策検討に必要なアンケート調査の実施
        </ListItem>
        <ListItem>ユーザーからの各種お問い合わせへの対応</ListItem>
        <ListItem>その他個人情報等の取得時に明示した目的のため</ListItem>
        <ListItem>第15条 （個人情報の第三者提供）</ListItem>
      </UnorderedList>
      <Text fontWeight="medium">
        当社は、以下に定める利用目的の範囲内で、当社グループ会社に対して、ユーザーの個人情報を提供することがあり、ユーザーは、これに同意するものとします。
      </Text>
      <UnorderedList fontWeight="medium" spacing={1} mt={2}>
        <ListItem>ユーザーへのお知らせ等の発送・発信</ListItem>
        <ListItem>本サービスの提供</ListItem>
        <ListItem>
          当社等が取り扱う商品及び提供する各種サービスに関する企画、開発、宣伝、販売・サービス活動、品質向上、リコールへの対応
        </ListItem>
        <ListItem>
          当社等の商品・サービス企画、開発、お客様満足度向上策検討に必要なアンケート調査の実施
        </ListItem>
        <ListItem>ユーザーからの各種お問い合わせへの対応</ListItem>
        <ListItem>その他個人情報等の取得時に明示した目的のため</ListItem>
      </UnorderedList>
      <Text fontWeight="bold" mt={2}>
        第16条（匿名加工情報の提供）
      </Text>
      <Text fontWeight="medium">
        当社は、取得した個人情報を、それ自体では特定の個人が識別できないよう加工したうえで、第三者に提供する場合があり、ユーザーはこれに同意します。この場合、当社は、当該情報を提供する第三者に対して、特定の個人の識別につながる行為を禁止するなどの安全管理措置を講ずるものとします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第17条（著作権等）
      </Text>
      <Text fontWeight="medium">
        本サービスを通じて提供されるテキスト、画像、写真、音声、動画及び情報等（以下「テキスト等」といいます。）に関する著作権、商標権及び意匠権等の知的財産権は、当社その他正当な権限者に帰属しています。ユーザーは、本サービスを通じて取得した著作物等を、当社が明示的に許諾した範囲及び著作権法で認められた私的使用の範囲を超えて使用することはできないものとします。
      </Text>
      <Text fontWeight="medium">
        当社に寄せられた本サービスに係る提案、感想その他の意見（以下「提案等」といいます。）に関する著作権（著作権法第27条及び第28条の権利を含みます。）その他一切の権利は、当社に帰属するものとします。当社に提案等を行う者は、当該提案等について著作者人格権を行使しないものとします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第18条（本規約の変更）
      </Text>
      <Text fontWeight="medium">
        当社は、当ウェブサイトへの掲載その他当社が適切と認める方法により本規約の変更をユーザーに周知することにより、本規約の内容を変更することができるものとします。
      </Text>
      <Text fontWeight="medium">
        当社が当ウェブサイトへの掲載をもって本規約の変更を周知する場合には、当該掲載の時点をもって変更の効力が生じるものとします。ただし、変更内容がユーザーに重大な影響を与えると当社が判断する場合には、当社は、合理的な予告期間をもって変更を周知するものとします。
      </Text>
      <Text fontWeight="medium">
        ユーザーは、本規約の変更の効力発生後に本サービス等を利用した場合には、変更後の本規約に同意したものとみなされます。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第19条（損害賠償）
      </Text>
      <Text fontWeight="medium">
        ユーザーの本規約に違反する行為、または不正若しくは違法な行為によって、当社に損害が生じ、またはそのおそれを生じさせた場合には、当社は、ユーザーに対して、当該行為の差し止めや当社の被った損害の賠償を請求することができるものとします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第20条（免責事項）
      </Text>
      <Text fontWeight="medium">
        当社は、IDの利用及び本サービスについて、特定の目的への適合性、有用性、正確性及び完全性について何ら保証するものではなく、これらの利用または利用不能から生じる損害について、ユーザーに対して一切責任を負いません。
      </Text>
      <Text fontWeight="medium">
        当社は、次の各号に定める事由によりユーザーに損害が生じたとしても、これについて一切責任を負いません。
      </Text>
      <UnorderedList fontWeight="medium" spacing={1} mt={2}>
        <ListItem>
          当社が相当の安全策を講じたにもかかわらず、第三者による不正アクセスまたはコンピュータウイルスの混入等の不正行為が行われたこと
        </ListItem>
        <ListItem>
          通信回線、システムまたはサーバー等の障害による本サービスの提供等の中断、遅滞、不能またはデータ消失等
        </ListItem>
      </UnorderedList>
      <Text fontWeight="medium">
        当社は、ユーザーと第三者（他のユーザーを含みますが、これらに限りません。）との間で生じた紛争について、一切責任を負いません。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第21条（連絡方法）
      </Text>
      <Text fontWeight="medium">
        IDの利用及び本サービス等に関するお問い合せ・ご相談その他ユーザーの当社に対する連絡または通知、及び当社からユーザーに対する連絡または通知は、それぞれ当社所定の方法で行うものとします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第22条（準拠法）
      </Text>
      <Text fontWeight="medium">
        本規約は日本法に準拠し、同法に従い解釈されるものとします。
      </Text>
      <Text fontWeight="bold" mt={2}>
        第23条（裁判管轄）
      </Text>
      <Text fontWeight="medium">
        ユーザーと当社との間で本規約に関して生じた紛争については、当社の本店所在地を管轄する裁判所を専属的合意管轄裁判所とします。
      </Text>
      <Text fontWeight="medium">
        以上
        <br />
        2025年8月18日
      </Text>
    </Box>
  );
}
